import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const lensSubmissionErrorsModalStyle = css`
    & .ant-modal-footer {
        padding: 0;
        background: ${Colors.Gray.V150};
        border: none;
    }
`;
